import { createIsRecommendedItem } from '@atlaskit/editor-common/quick-insert/is-recommended-item';
import {
	ADD_SUGGESTIONS_TO_CONTENT_SKILL_MENU_ITEM,
	ASK_ROVO_MENU_ITEM,
	CODE_BLOCK_MENU_ITEM,
	DATABASE_MENU_ITEM,
	DIAGRAM_MENU_ITEM,
	EMOJI_MENU_ITEM,
	HYPERLINK_MENU_ITEM,
	MEDIA_INSERT_MENU_ITEM,
	MENTION_MENU_ITEM,
	SYNCED_BLOCK_MENU_ITEM,
	TABS_MENU_ITEM,
} from '@atlaskit/editor-common/quick-insert/keys';
import type { QuickInsertPluginOptions } from '@atlaskit/editor-plugin-quick-insert/quick-insert-plugin-type';

type QuickInsertRecommendedItems = Required<
	Pick<QuickInsertPluginOptions, 'isRecommendedItem' | 'maxRecommendedItems'>
>;

/**
 * Each editor surface has its own recommendations because useful insertions vary by context.
 * Full-page keeps Synced block as an availability fallback for its primary recommendations.
 *
 * @see https://hello.atlassian.net/wiki/spaces/egcuc/pages/8041371137/Recommended+V2+Proposal
 */
export const fullPageQuickInsertRecommendedItems: QuickInsertRecommendedItems = {
	isRecommendedItem: createIsRecommendedItem([
		ASK_ROVO_MENU_ITEM.key,
		TABS_MENU_ITEM.key,
		DIAGRAM_MENU_ITEM.key,
		DATABASE_MENU_ITEM.key,
		ADD_SUGGESTIONS_TO_CONTENT_SKILL_MENU_ITEM.key,
		// Fallbacks
		SYNCED_BLOCK_MENU_ITEM.key,
	]),
	maxRecommendedItems: 5,
};

export const pageCommentQuickInsertRecommendedItems: QuickInsertRecommendedItems = {
	isRecommendedItem: createIsRecommendedItem([
		ASK_ROVO_MENU_ITEM.key,
		EMOJI_MENU_ITEM.key,
		MENTION_MENU_ITEM.key,
		DIAGRAM_MENU_ITEM.key,
		CODE_BLOCK_MENU_ITEM.key,
	]),
	maxRecommendedItems: 5,
};

export const inlineCommentQuickInsertRecommendedItems: QuickInsertRecommendedItems = {
	isRecommendedItem: createIsRecommendedItem([
		ASK_ROVO_MENU_ITEM.key,
		EMOJI_MENU_ITEM.key,
		MENTION_MENU_ITEM.key,
		MEDIA_INSERT_MENU_ITEM.key,
		HYPERLINK_MENU_ITEM.key,
	]),
	maxRecommendedItems: 5,
};

export const smartCreateQuickInsertRecommendedItems: QuickInsertRecommendedItems = {
	isRecommendedItem: createIsRecommendedItem([
		ASK_ROVO_MENU_ITEM.key,
		TABS_MENU_ITEM.key,
		DIAGRAM_MENU_ITEM.key,
		DATABASE_MENU_ITEM.key,
	]),
	maxRecommendedItems: 4,
};
